export default __webpack_public_path__ + "static/cafe_36034-a485842d178f5b78959fb429f4d12956.png";